import { render, staticRenderFns } from "./VatExpenseReportPrint.vue?vue&type=template&id=2b2435d2&"
import script from "./VatExpenseReportPrint.vue?vue&type=script&lang=js&"
export * from "./VatExpenseReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports